import React from 'react';
import CunoBackground from './CunoBackground';

interface CustomerBackgroundProps {
    className?: string; // Optional class for additional background styles
}

const CustomerBackground: React.FC<CustomerBackgroundProps> = ({ className }) => {
    const hostname = window.location.hostname;

    const renderBackground = () => {
        if (hostname.startsWith("192.168.") || hostname === 'localhost' || hostname === 'cuno.et360.de' || hostname === 'public.et360.de') {
            return <CunoBackground />;
        }
        return null; 
    };

    return (
        <div className={`fixed inset-0 w-full h-full ${className || ''} z-[-1]`}>
            {renderBackground()}
        </div>
    );
};

export default CustomerBackground;